'use client';

import Link from 'next/link';

import { useT } from '@/app/i18n/client';

export default function CommonCompanyIntroduction() {
  const { t } = useT('common');

  return (
    <footer className='mt-auto bg-gray-100 px-5 pb-20 pt-10 text-xs text-gray-400 shadow-sm max-md:pb-24'>
      <div className='mx-auto w-full max-w-7xl space-y-4 px-5 max-[1335px]:px-0'>
        {/* 회사 소개 */}
        <div className='space-y-1'>
          <p>WonderRound Co., Ltd.</p>
          <p>
            {t('footer.address')} 108 Toegye-ro, Jung-gu, Seoul, Republic of Korea |{' '}
            {t('footer.representative')} 묘청(MIAO QING), 김명각(Kim Myeong-gak) |{' '}
            {t('footer.businessNumber')} 335-87-02996
          </p>
          <p>
            {t('footer.eCommerceRegistrationNumber')} 2024-서울중구-1400 | {t('footer.email')}{' '}
            contact@wonderround.com | {t('footer.phone')} +82 2-318-8814
          </p>
        </div>

        {/* 약관 */}
        <div className='space-x-4'>
          <Link href='/terms/service' className='underline'>
            {t('footer.termsOfService')}
          </Link>
          <Link href='/terms/privacy-policy' className='font-medium text-[#2E2E2E] underline'>
            {t('footer.privacyPolicy')}
          </Link>
          <a
            className='underline'
            href='https://www.ftc.go.kr/bizCommPop.do?wrkr_no=3358702996'
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('footer.businessInformation')}
          </a>
        </div>

        {/* 저작권 */}
        <p>ⓒ WonderRound Co., Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
}
